import { Outlet } from "@tanstack/react-router";
import { RequireAuth } from "@/auth/require-auth";
import { Toaster } from "@/components/ui/sonner";
import { DashboardLayout } from "@/layout/dashboard-layout";

export function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster richColors position="top-right" />
    </>
  );
}

export function AppShell() {
  return (
    <RequireAuth>
      <DashboardLayout />
    </RequireAuth>
  );
}
